/** Headings rendered between groups of registry-driven fields.
 *  Pure presentation. */
import { useSlotLabel } from "../hooks/useSlotLabels";

export function VehicleMassHeadingSlot() {
  const lbl = useSlotLabel("vehicle.mass-heading");
  return (
    <h4 className="text-xs font-semibold uppercase tracking-wider text-slate-500 pt-3">
      {lbl("title", "Mass limits (kg)")}
    </h4>
  );
}
export default VehicleMassHeadingSlot;
